import { useEffect, useState } from "react";
import { getCampaignProgress } from "../../../services/notification";

const EMPTY_PROGRESS = {
  today: { remaining: 0, total: 0, treated: 0 },
  week: [],
  alerts: { treated: 0, total: 0, percent: null },
};

export const useCampaignProgress = (campaignId) => {
  const [progress, setProgress] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!campaignId) {
      setProgress(null);
      setIsLoading(false);
      return;
    }

    let cancelled = false;

    const fetchProgress = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await getCampaignProgress(campaignId);
        if (!cancelled) {
          setProgress(response.data?.progress ?? null);
        }
      } catch (err) {
        console.error("Error fetching campaign progress:", err);
        if (!cancelled) {
          setError(err);
          setProgress(EMPTY_PROGRESS);
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    };

    fetchProgress();

    return () => {
      cancelled = true;
    };
  }, [campaignId]);

  return { progress, isLoading, error };
};
